import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { openListJson } from '@/views/system/homePage/server';

export interface HomeNewSuitsState {
  isWorldLegend: boolean;
  list: openListJson[];
  clientTime: number;
}

const HOMENEWSUIT_KEY = 'React-ts-ant-homeNewSuit';

const localHomeSuits = LocalStore.getValue<HomeNewSuitsState>(HOMENEWSUIT_KEY) || {};

export const defaults: HomeNewSuitsState = {
  isWorldLegend: false,
  clientTime: 0,
  list: [],
  ...localHomeSuits
};

const HOME_NEWSUIT_KEY = 'React-ts-ant-HOMENEWSUITS';

export const updateHomeNewSuits: (homeNewSuits: HomeNewSuitsState) => IAction<HomeNewSuitsState> = (
  homeNewSuits: HomeNewSuitsState
) => ({
  type: HOME_NEWSUIT_KEY,
  payload: homeNewSuits
});

const homeNewSuitReducer: Reducer<HomeNewSuitsState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case HOME_NEWSUIT_KEY:
      LocalStore.setValue(HOMENEWSUIT_KEY, payload as HomeNewSuitsState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default homeNewSuitReducer;
